'use strict';

exports.__esModule = true;

var _katex = require('katex');

var _katex2 = _interopRequireDefault(_katex);

require('katex/dist/katex.min.css');

var _globalutil = require('../util/globalutil');

var _globalutil2 = _interopRequireDefault(_globalutil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*--------------------------
    Variable
--------------------------*/
var getYoutubeInfo = _globalutil2.default.getYoutubeInfo,
    checkIsVideoFile = _globalutil2.default.checkIsVideoFile;

/*--------------------------
    Methods
--------------------------*/

// ------------------------------
// [private] 把空白以及換行去掉，減少文字size
// ------------------------------

// import { result } from 'lodash';
/*=====================================
    轉換 html code

    Author: Gray
    CreateTime: 2020 / 12 / 03
=====================================*/

// 數學式相關檔案

function _zipcodeText(text) {

    return text.replace(/[\s]{2,}/g, " ");
}

// ------------------------------
// [private] _getPreviewLatexHtmlText
// ------------------------------
function _getPreviewLatexHtmlText(oriValue, latexHtml, isBlock) {

    var result = '';

    var textAraaStyle = '\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 0px;\n        height: 0px;\n        opacity: 0;\n        display: none;\n    ';

    textAraaStyle = _zipcodeText(textAraaStyle);

    var lessthenRegex = "###md_code_symbol_lessthen###";
    var formatText = oriValue.replace(/</g, lessthenRegex);
    var contenClass = isBlock ? "cupoymd-latex-code-block" : "cupoymd-latex-code-inline";

    result += '<span class="' + contenClass + '" widget-latex-code>';
    result += '<textarea style="' + textAraaStyle + '" readonly lessthen-regex="' + lessthenRegex + '">' + formatText + '</textarea>';
    result += latexHtml;
    result += '</span>';

    return result;
}

// ------------------------------
// [private] replaceLatexBlock
// ------------------------------
function _replaceLatexBlock(match, group1, offset) {

    if (!group1) {
        return match;
    }

    var latexText = group1.trim();

    var latexHtml = _katex2.default.renderToString(latexText, {
        throwOnError: false,
        displayMode: true
    });

    return _getPreviewLatexHtmlText(latexText, latexHtml, true);
}

// ------------------------------
// [private] replaceLatexInline
// ------------------------------
function _replaceLatexInline(match, group1, offset) {

    if (!group1) {
        return match;
    }

    var latexText = group1.trim();

    var latexHtml = _katex2.default.renderToString(latexText, {
        throwOnError: false
    });

    return _getPreviewLatexHtmlText(latexText, latexHtml, false);
}

// ------------------------------
// 將字串內的 latex 轉換成 html
// ------------------------------
function formatTextToLatexHtml(text) {

    var result = text;

    // 用 $$$$ text $$$$ 包的內容 轉換成block的 數學式
    result = result.replace(/\$\$\$\$((?:.|\s)[^\$]*)\$\$\$\$/g, _replaceLatexBlock);

    // 用 $$ text $$ 包的內容 轉換成inline的 數學式
    result = result.replace(/\$\$((?:.|\s)[^\$]*)\$\$/g, _replaceLatexInline);

    return result;
}

// ------------------------------
// 將字串內的 yotube 轉換成 html
// ------------------------------
function formatYTLinkToHtml(text) {

    var result = text;

    // 用 (yt@ text @yt) 包的內容 轉換成 youtube iframe
    result = result.replace(/\(yt>([^\)]*)<yt\)/g, function (match, group1, offset) {

        if (!group1) {
            return match;
        }

        var link = group1.trim();
        var info = getYoutubeInfo(link);

        if (!info) {
            return match;
        }

        var src = 'https://www.youtube.com/embed/' + info.srcID + '?rel=0&showinfo=0&enablejsapi=1&version=3&playerapiid=ytplayer';
        var html = '<div class="cupoymd-youtube-block"><iframe src="' + src + '" frameborder="0" allowfullscreen></iframe></div>';

        return html;
    });

    return result;
}

// ------------------------------
// 將字串內的 latex 移除
// ------------------------------
function removeLatexContent(text) {

    var result = text;

    // 用 $$$$ text $$$$ 包的內容 全部移除
    result = result.replace(/\$\$\$\$((?:.|\s)[^\$]*)\$\$\$\$/g, '');

    // 用 $$ text $$ 包的內容 全部移除
    result = result.replace(/\$\$((?:.|\s)[^\$]*)\$\$/g, '');

    return result;
}

// ------------------------------
// 將字串內的 yotube 移除
// ------------------------------
function removeYTLinkContent(text) {

    var result = text;

    // 用 (yt@ text @yt) 包的內容 全部移除
    result = result.replace(/\(yt>([^\)]*)<yt\)/g, '');

    return result;
}

// ------------------------------
// 將已經完成markdown字串轉換的 html 裡面的特殊符號給取代成正確的HTML內容
// ------------------------------
function formatFontStyleToHtml(text) {

    var result = text;

    // console.log('formatFontStyleToHtml start = ' + text);

    // 不管前後標籤，直接把所有符合的內容 replace 成 HTML 符號

    // 用 ((fs>${fontisze}: * <fs)) 包的內容 轉換成 font size
    result = result.replace(/\(fs&gt;([^]*?):/g, function (match, group) {

        if (!group) {
            return '<span>';
        }

        var fontsize = Number(group);
        if (!fontsize || isNaN(fontsize)) return '<span>';

        return '<span style="font-size: ' + fontsize + 'px;">';
    });
    result = result.replace(/&lt;fs\)/g, function (match, group) {

        return '</span>';
    });

    // 用 ((fc>${color}: * <fc)) 包的內容 轉換成 font color
    result = result.replace(/\(fc&gt;([^]*?):/g, function (match, group) {

        if (!group) {
            return '<span>';
        }

        var color = group;
        if (!color) return '<span>';

        return '<span style="color: ' + color + ';" class="cmd-text-color">';
    });
    result = result.replace(/&lt;fc\)/g, function (match, group) {

        return '</span>';
    });

    // 用 ((ta>${align}: * <ta)) 包的內容 轉換成 text-align
    result = result.replace(/\(ta&gt;([^]*?):<br>/g, function (match, group) {
        // 因為在功能上故意加了一個換行的符號，所以會跑出一個<br>嘗試把它取代掉，這樣可能比較不會造成使用者的疑惑

        if (!group) {
            return '<span>';
        }

        var align = group;
        if (!align) return '<span>';

        return '<span class="text-' + align + '">';
    });
    result = result.replace(/\(ta&gt;([^]*?):/g, function (match, group) {

        if (!group) {
            return '<span>';
        }

        var align = group;
        if (!align) return '<span>';

        return '<span class="text-' + align + '">';
    });
    result = result.replace(/&lt;ta\)/g, function (match, group) {

        return '</span>';
    });

    return result;
}

// ------------------------------
// 檢查檔案內容是否為 影片類型
// ------------------------------
function isMediumFile(href, title, text) {

    return checkIsVideoFile(href, text);
}

// ------------------------------
// 將影片內容轉換成 video html
// ------------------------------
function formatMediumFileToHtml(href, title, text) {

    return '\n        <video controls>\n            <source src=' + href + '>\n        </video>\n    ';
}

/*--------------------------
    Export
--------------------------*/
var FormatUtil = {
    formatTextToLatexHtml: formatTextToLatexHtml, // 將字串內的 latex 轉換成 html
    formatYTLinkToHtml: formatYTLinkToHtml, // 將字串內的 yotube 轉換成 html
    removeLatexContent: removeLatexContent, // 將字串內的 latex 移除
    removeYTLinkContent: removeYTLinkContent, // 將字串內的 yotube 移除
    formatFontStyleToHtml: formatFontStyleToHtml, // 將已經完成markdown字串轉換的 html 裡面的特殊符號給取代成正確的HTML內容
    isMediumFile: isMediumFile, // 檢查檔案內容是否為 影片類型
    formatMediumFileToHtml: formatMediumFileToHtml // 將影片內容轉換成 video html

};

exports.default = FormatUtil;
module.exports = exports['default'];